import React from "react"
import { Link } from "gatsby"
import styles from "./FAQ.module.scss"

const questionsAndAnswers = [
  {
    q:
      "What are the alternatives to the EngineID identity and access management platform?",
    a: (
      <React.Fragment>
        <p>
          The alternative is to buy a platform for large enterprises from
          another vendor that you’ll need to implement yourself or hire a
          third-party organization to implement and maintain. Either way, it
          will take several months to get the implementation done correctly for
          your business.
        </p>
        <p>
          Not only are oversized solutions and consultants expensive options,
          but you may not use or need all the functionality of the platform, or
          it may take a significant amount of time to realize the value.
        </p>
      </React.Fragment>
    ),
  },
  {
    q:
      "Do you support all of my applications? Even the ones not listed on the EngineID website?",
    a: (
      <React.Fragment>
        <p>
          EngineID already supports many applications, but if you don't see your 
          apps on our site, don't worry! We are adding new applications all the time 
          and will be more than happy to get yours onboarded, free of charge. Our aim 
          is to give you the best experience possible with EngineID, and we will do 
          everything we can to get you up and running.
        </p>
        <p>
          Please note that if your applications don't support standards like SAML or 
          OpenID Connect, we will help with onboarding on a best-effort basis. Our expert 
          team will investigate all avenues to try to get you the result you are after.
        </p>
      </React.Fragment>
    ),
  },
  { 
    q: "Will digital security breaches be prevented?", 
    a: (
      <React.Fragment>
        <p>
          Yes. Even though our user interface is simple, it’s also extremely secure and
          will prevent security breaches.
        </p>
        <p>
          How can we be so sure?
        </p>
        <p>
          First, searching for security holes and back doors is our specialty. Before we
          developed this application, we were in the digital data security business, so
          we’re aware of security issues and what types of functionality in platform
          applications can lead to human error.
        </p>
        <p>
          That’s why we’ve created a simple user interface that doesn’t have thousands
          of options for users to accidentally create access that opens the back door to
          the company data.
        </p>
        <p>
          Second, we don’t self-certify our platform. We invest in having it tested and
          externally certified. This means that the independent third-party certifier
          accesses our platform and tries to hack it by searching for holes or security
          breaches.
        </p>
        <p>
          Finally, we trust our own platform for the identity management of our own
          company.
        </p>
      </React.Fragment>
    ),
  },
  { 
    q: "Can EngineID be personalized for our business?", 
    a: (
      <React.Fragment>
        <p>
          Yes! We’re designed to be responsive and to give our clients what they want.
          This means providing you with dynamic solutions that cater to your different requirements.
        </p>
      </React.Fragment>
    ),
  },
  { 
    q: "Can we access EngineID from anywhere?", 
    a: (
      <React.Fragment>
        <p>
          Yes. Because EngineID is cloud-based, it can easily be
          accessed on your employees’ desktops in all of your offices, including satellite
          offices, and when the employees are working remotely.
        </p>
      </React.Fragment>
    ),
  },
  { 
    q: "How many employees/members can work in EngineID?",
    a: (<React.Fragment><p>As many as you want! You can have unlimited users.</p></React.Fragment>),
  },
  {
    q: "Is it easy to remove employees if they leave our company?",
    a: (
      <React.Fragment>
        <p>
          Yes, if the employee leaves the organization, it’s simply a matter of disabling
          or removing the user altogether. Then, they’ll no longer have access to any of
          the applications.
        </p>
      </React.Fragment>
    ),
  },
  {
    q: "Isn't it risky to have one account to access all my applications?",
    a: (
      <React.Fragment>
        <p>
          To alleviate any concerns with password security, EngineID offers multi-factor
          authentication to add an additional security layer to your account. When you
          sign in, you’ll be asked for a password and a secret code, which is generated
          from an app such as Google Authenticator from your mobile device.
        </p>
        <p>
          This means when you sign in, you need to provide something you know
          (your password) and something you have (a secret code generated from your
          mobile device).
        </p>
      </React.Fragment>
    ),
  },
  {
    q:
      "Our company is growing quickly, which means our employees' roles change constantly. How easy is it to assign the right applications to each role?",
    a: (
      <React.Fragment>
        <p>
          In the EngineID platform, each employee is created as a user only once. You
          also create the multiple roles found within your company, for example, a
          software or sales role. Each role has access to a group of applications that you
          select. When an employee joins or changes job, you assign them to the right
          role, and they’ll immediately have access to the applications associated with
          their new position.
        </p>
      </React.Fragment>
    ),
  },
  {
    q:
      "Do I need to be tech-savvy to use EngineID identity and access management?",
    a: (
      <React.Fragment>
        <p>
          Not at all! We’ve simplified EngineID as much as possible to give you a great
          user experience. It’s quick and easy to access using the internet, uses simple
          language and incorporates existing web apps. What’s more, the platform
          enables single sign-on. In plain English, that means one password for all your
          work apps.
        </p>
      </React.Fragment>
    ),
  },
  { 
    q: "How do we get started?", 
    a: (
      <React.Fragment>
        <p>
          It’s quick and easy to get started. Simply click on the link to register for a free
          version of EngineID. This will give you immediate access, which only takes
          two minutes to set up. If you decide to upgrade to the full version, you can do
          this with a simple click of a button.
        </p>
      </React.Fragment>
    ), 
  },
  {
    q: (
      <p className={styles.question + " proxima-nova--semi-bold fs-18pt"}>
        Couldn’t find what you are looking for?{" "}
        <u className={styles.contactUs}>Contact us!</u>
      </p>
    ),
    a: (<React.Fragment><p><Link
      className={"nav-link proxima-nova--semi-bold fs-14pt ls-1px"}
      activeClassName="active"
      to={"/contact-us"}
    >
      Click here to contact us for more information.
    </Link></p></React.Fragment>),
  },
]

export default questionsAndAnswers
